var forEach = require('../array/forEach');

    /**
     * Create nested object if non-existent
     */
    function namespace(obj, path){
        if (!path) return obj;
        forEach(path.split('.'), function(key){
            if (!obj[key]) {
                obj[key] = {};
            }
            obj = obj[key];
        });
        return obj;
    }

    module.exports = namespace;





/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/object/namespace.js
 ** module id = 28
 ** module chunks = 0
 **/